import { Buffer as BufferPolyfill } from "buffer";

export const polyfillBuffer = () => {
  globalThis.Buffer = BufferPolyfill;
};
